/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken, getParams } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';
import { NotificationManager } from 'react-notifications';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import GiftCardForm from './partials/GiftCardForm';

import './ProGiftCards.css';
import {
  register,
  fetchUser,
  listCompanies,
  connectStripe,
  updateCompany,
} from '../actions';


class ProGiftCards extends OzComponent {

  static need = [
    ['user', fetchUser],
  ];

  componentDidMount() {
    this.props.listCompanies({ mine: 1 });
  }

  save(e, values) {
    let companies = this.props.companies;
    let company = companies.items[0];
    this.props.updateCompany(company.id, values)
      .then(resp => {
        if (resp.error) return;
        NotificationManager.success('Saved your gift card');
      });
  }

  renderGiftCards() {
    let companies = this.props.companies;
    if (!companies) return;
    let company = companies.items[0];
    return (
      <div>
        <p>You can add gift cards for <b>{company.name}</b> here.</p>
        <p>To be featured in our upcoming COVID-19 gift card list, your gift card must include a discount.</p>

        <GiftCardForm
          errors={this.props.errors.updateCompany}
          values={company}
          buttonText="Save"
          onSubmit={(e, values) => this.save(e, values)}
        />
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="ProGiftCards" padded pro>
        <div className="pro-header">Gift Cards</div>
        {this.renderGiftCards()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    companies: state.list.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    register,
    fetchUser,
    listCompanies,
    updateCompany,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProGiftCards);



/** WEBPACK FOOTER **
 ** ./src/components/ProGiftCards.js
 **/